import {DF_FLOW_PARAM} from './constants'

// DF_FLOW_PARAM tells the post-reload AP page to resume the deal-freeze flow.
export const getLandingUrlWithDFParam = () => {
  const params = new URLSearchParams(window.location.search)
  params.set(DF_FLOW_PARAM, '1')
  const search = params.toString()
  return `${window.location.origin}${window.location.pathname}?${search}${window.location.hash}`
}
